var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2148 1.56641C6.41584 1.56641 1.71484 5.81941 1.71484 11.0664C1.71484 13.5934 2.81284 15.8834 4.59084 17.5864L3.72284 21.8354C3.70436 21.9263 3.71152 22.0205 3.74351 22.1076C3.77551 22.1946 3.83108 22.271 3.90403 22.3283C3.97697 22.3856 4.0644 22.4214 4.15655 22.4319C4.2487 22.4423 4.34194 22.4269 4.42584 22.3874L9.15684 20.1544C10.1531 20.4281 11.1817 20.5667 12.2148 20.5664C18.0138 20.5664 22.7148 16.3134 22.7148 11.0664C22.7148 5.81941 18.0138 1.56641 12.2148 1.56641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMessage);
export default __webpack_public_path__ + "static/media/whiteMessage.25d4db16291601738ad4eb228d61f777.svg";
export { ForwardRef as ReactComponent };